<template>
  <div class="card">
    <div class="card-body">
      <h4 class="card-title">Персональные скидки</h4>

      <div class="discount__items">
        <div
          v-for="(discount, index) in localDiscounts"
          :key="'discount' + index"
          class="discount__item"
        >
          <div
            class="discount__item-del"
            role="button"
            tabindex="0"
            @click="removeDiscount(discount, index)"
          >
            <svg
              width="10"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 320 512"
            >
              <path
                fill="currentColor"
                d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
              />
            </svg>
          </div>

          <v-select
            v-model="discount.user"
            label="name"
            :filterable="false"
            :options="userOptions"
            class="mb-1"
            placeholder="Поиск по email"
            @search="onUserSearch"
          >
            <template #no-options>
              Введите почту пользователя
            </template>

            <template #option="option">
              <div class="d-center">
                {{
                  `${option.id} - ${option.name} ${option.surname} (${option.email})`
                }}
              </div>
            </template>

            <template #selected-option="option">
              <div class="selected d-center">
                {{
                  `${option.name} ${option.surname} (${option.email})`
                }}
              </div>
            </template>
          </v-select>

          <b-form-input
            v-model.number="discount.value"
            type="number"
            no-wheel
            placeholder="Скидка в %"
            class="inline-block mb-1"
          />
        </div>
      </div>

      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        class="mr-1 mt-1"
        @click="addDiscount"
      >
        Добавить скидку
      </b-button>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        v-b-modal.modal-discount
        variant="primary"
        class="mr-1 mt-1"
      >
        Загрузить из шаблона
      </b-button>
      <add-discounts-templates-modal @select="onSelectTemplate" />
    </div>
  </div>
</template>

<script>
import { BFormInput, BButton } from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import AddDiscountsTemplatesModal from '../templates/discounts/AddDiscountsTemplatesModal.vue'

export default {
  name: 'PersonalDiscountsSection',

  components: {
    BFormInput,
    BButton,
    vSelect,
    AddDiscountsTemplatesModal,
  },

  directives: {
    Ripple,
  },

  props: {
    personalDiscounts: {
      type: Array,
      default: () => [],
    },
    userOptions: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    localDiscounts: {
      get() {
        return Array.isArray(this.personalDiscounts)
          ? this.personalDiscounts
          : []
      },
      set(val) {
        this.$emit('update:personalDiscounts', val)
      },
    },
  },

  methods: {
    addDiscount() {
      this.localDiscounts = [
        ...this.localDiscounts,
        { user: null, value: null },
      ]
    },

    removeDiscount(discount, index) {
      this.$emit('delete-discount', discount, index)
    },

    onUserSearch(search, loading) {
      this.$emit('search-users', search, loading)
    },

    onSelectTemplate(payload) {
      this.$emit('add-from-template', payload)
    },
  },
}
</script>

<style scoped lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.discount__items {
  margin: 0 -15px;
  display: flex;
  flex-wrap: wrap;
}

.discount__item {
  position: relative;
  margin: 0 15px 10px 15px;
  display: flex;
  flex-direction: column;
  min-width: 300px;
  max-width: max-content;
  box-shadow: 0 0 23px -2px rgba(34, 60, 80, 0.2);
  border-radius: 20px;
  padding: 25px;

  &-del {
    position: absolute;
    right: 9px;
    top: 5px;
    cursor: pointer;
    transition: 0.3s;
    color: #6e6b7b;

    &:hover {
      transform: scale(1.2);
    }
  }
}
</style>
